/* eslint-disable max-len */
import PropTypes from 'prop-types';

import IconBase from './icon-base';

const IconDaylightNight = ({ className, height, width }) => (
  <IconBase className={className} viewBox="0 0 26 26" width={width} height={height}>
    <path
      d="M14.2988 24.96C18.0676 24.96 21.5098 23.2817 23.7902 20.5315C24.1275 20.1246 23.7597 19.5303 23.2383 19.6275C17.3102 20.7326 11.8662 16.2835 11.8662 10.426C11.8662 7.0519 13.7115 3.94917 16.7107 2.27855C17.173 2.02104 17.0567 1.33497 16.5314 1.24C15.795 1.10708 15.0477 1.04015 14.2988 1.04004C7.55422 1.04004 2.08008 6.38985 2.08008 13C2.08008 19.6018 7.54563 24.96 14.2988 24.96Z"
      fill="white"
    />
  </IconBase>
);

IconDaylightNight.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

IconDaylightNight.defaultProps = {
  className: null,
  height: 26,
  width: 26,
};

export default IconDaylightNight;
